module.exports = __webpack_public_path__ + "img/21.08005db7.jpg";